module.exports = __webpack_public_path__ + "media/images/athletes/1755-543374c97022056c25cf3512bef9b224.png";